module.exports = __webpack_public_path__ + "img/icon-link.a36ffb7c.svg";